import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as questionCatalogService from "@/modules/newCommunity/pages/operationTools/api/questionCatalogService";
import * as baseQuestionnaireService from "@/modules/newCommunity/pages/operationTools/api/baseQuestionnaireService";
import authCodeMap from "@/dataBase/authCodeMap";
export default {
  data() {
    return {
      isDoctorCommunity: false,
      isPatientCommunity: false,
      communityType: "",
      questionaireManageTabPanePermission: "",
      questionBankTabPanePermission: "",
      addQuestionRouterName: "",
      catalogManageRouterName: ""
    };
  },
  created() {
    if (this.$route.path.includes("newCommunity")) {
      this.isDoctorCommunity = true;
      this.communityType = "DOCTOR";
      this.addQuestionRouterName = "newCom_operationTools_addQuestion";
      this.catalogManageRouterName = authCodeMap.newCom_operationTools_catalogManage;
      this.operationToolsQuestionnaireRouterName = authCodeMap.newCom_operationTools_questionnaire_questionBank;
      this.questionaireManageTabPanePermission = "newCom_operationTools_questionnaire_questionaireManage";
      this.questionBankTabPanePermission = "newCom_operationTools_questionnaire_questionBank";
    } else {
      this.isPatientCommunity = true;
      this.communityType = "PATIENT";
      this.addQuestionRouterName = "newCom_operationTools_addQuestion";
      this.catalogManageRouterName = authCodeMap.newCom_operationTools_catalogManage;
      this.operationToolsQuestionnaireRouterName = authCodeMap.newCom_operationTools_questionnaire_questionBank;
      this.questionaireManageTabPanePermission = "newCom_operationTools_questionnaire_questionaireManage";
      this.questionBankTabPanePermission = "newCom_operationTools_questionnaire_questionBank";
    }
  },
  methods: {
    getCatalogSelectList(callBack) {
      questionCatalogService.getList({
        communityType: this.communityType
      }).then(res => {
        if (res.code === 200) {
          callBack([{
            label: "全部",
            value: null
          }, ...res.data.map(item => ({
            label: item.name,
            value: item.id
          }))]);
        }
      });
    },
    getCatalogCreateSelectList(callBack) {
      questionCatalogService.getCreateList({
        communityType: this.communityType
      }).then(res => {
        if (res.code === 200) {
          callBack([{
            label: "全部",
            value: null
          }, ...res.data.map(item => ({
            label: item.name,
            value: item.userId
          }))]);
        }
      });
    },
    getQuestionnaireCreateSelectList(callBack) {
      baseQuestionnaireService.getQuestionCreateList({
        communityType: this.communityType
      }).then(res => {
        if (res.code === 200) {
          callBack([{
            label: "全部",
            value: null
          }, ...res.data.map(item => ({
            label: item.name,
            value: item.userId
          }))]);
        }
      });
    }
  }
};